module.exports = __webpack_public_path__ + "static/w-lusi-017bf41bf13d2a2b397aaa785e3b0878.jpg";